
import { useState, useEffect } from 'react';

interface Testimonial {
  id: number;
  name: string;
  position: string;
  company: string;
  content: string;
  rating: number;
  avatar: string;
  projectType: string;
}

export default function TestimonialsSection() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const testimonials: Testimonial[] = [
    {
      id: 1,
      name: 'Mehmet Yılmaz',
      position: 'Genel Müdür',
      company: 'TechVision Ltd.',
      content:
        'AYYILDIZ DİGİTAL ile çalışmak harika bir deneyimdi. Web sitemizi sıfırdan tasarladılar ve sonuç beklentilerimizi fazlasıyla karşıladı. Profesyonel yaklaşımları ve zamanında teslimatları mükemmeldi.',
      rating: 5,
      avatar:
        'https://public.readdy.ai/ai/img_res/f062a46c0a3d56a6add29cd4f6c87e0b.jpg',
      projectType: 'Kurumsal Web Sitesi',
    },
    {
      id: 2,
      name: 'Ayşe Demir',
      position: 'Pazarlama Müdürü',
      company: 'Fashion Boutique',
      content:
        "E-ticaret sitemiz için aldığımız hizmet gerçekten üst düzeydeydi. Satışlarımız %300 arttı! Mobil uyumlu tasarım ve SEO optimizasyonu sayesinde Google'da ilk sıralardayız.",
      rating: 5,
      avatar:
        'https://readdy.ai/api/search-image?query=Professional%20Turkish%20businesswoman%20portrait%2C%20marketing%20executive%2C%20confident%20smile%2C%20modern%20business%20attire%2C%20office%20environment%2C%20professional%20headshot%2C%20high%20quality&width=100&height=100&seq=avatar-2&orientation=squarish',
      projectType: 'E-Ticaret Platformu',
    },
    {
      id: 3,
      name: 'Ali Kaya',
      position: 'Kurucu',
      company: 'StartupTech',
      content:
        'Mobil uygulama geliştirme konusunda gerçekten uzman bir ekip. Fikirlerimizi mükemmel bir şekilde hayata geçirdiler. Kullanıcı deneyimi harika, performans mükemmel!',
      rating: 5,
      avatar:
        'https://readdy.ai/api/search-image?query=Young%20Turkish%20entrepreneur%20portrait%2C%20startup%20founder%2C%20casual%20business%20attire%20modern%20tech%20office%2C%20confident%20expression%2C%20professional%20photo%2C%20high%20quality&width=100&height=100&seq=avatar-3&orientation=squarish',
      projectType: 'Mobil Uygulama',
    },
    {
      id: 4,
      name: 'Fatma Özkan',
      position: 'İşletme Sahibi',
      company: 'Özkan Danışmanlık',
      content:
        'Dijital pazarlama hizmetleri sayesinde online görünürlüğümüz inanılmaz arttı. SEO ve sosyal medya stratejileri çok etkili oldu. Kesinlikle tavsiye ediyorum!',
      rating: 5,
      avatar:
        'https://readdy.ai/api/search-image?query=Professional%20Turkish%20businesswoman%20consultant%2C%20mature%20professional%2C%20business%20suit%2C%20office%20environment%2C%20confident%20smile%2C%20corporate%20headshot%2C%20high%20quality%20professional%20photo&width=100&height=100&seq=avatar-4&orientation=squarish',
      projectType: 'Dijital Pazarlama',
    },
    {
      id: 5,
      name: 'Emre Şahin',
      position: 'E-Ticaret Müdürü',
      company: 'Şahin Gıda',
      content:
        'Online mağazamızın yeniden tasarımı harika oldu. Kullanıcı dostu arayüz ve hızlı yükleme süreleri müşteri memnuniyetimizi artırdı. Çok memnunuz!',
      rating: 5,
      avatar:
        'https://readdy.ai/api/search-image?query=Professional%20Turkish%20business%20manager%2C%20e-commerce%20executive%2C%20modern%20business%20casual%20office%20background%2C%20confident%20professional%20look%2C%20high%20quality%20portrait&width=100&height=100&seq=avatar-5&orientation=squarish',
      projectType: 'E-Ticaret Yenileme',
    },
  ];

  useEffect(() => {
    // IntersectionObserver kontrolü - SSR uyumluluğu için
    if (typeof window === 'undefined' || !window.IntersectionObserver) {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const section = document.getElementById('testimonials');
    if (section) observer.observe(section);

    // Auto-rotate testimonials
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, [testimonials.length]);

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i
        key={index}
        className={`ri-star-${index < rating ? 'fill' : 'line'} ${
          index < rating ? 'text-yellow-400' : 'text-gray-400'
        }`}
        aria-hidden="true"
      ></i>
    ));
  };

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-br from-gray-900 via-blue-950 to-gray-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-cyan-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-blue-500/20 backdrop-blur-sm rounded-full border border-blue-400/30 mb-6">
            <i className="ri-chat-quote-line text-blue-400 mr-2"></i>
            <span className="text-blue-400 text-sm font-medium">Müşteri Görüşleri</span>
          </div>

          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Müşterilerimiz Ne Diyor?
            </span>
          </h2>

          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Memnun müşterilerimizin deneyimlerini okuyun ve neden AYYILDIZ DİGİTAL'i tercih
            ettiklerini öğrenin.
          </p>
        </div>

        {/* Main Testimonial Display */}
        <div
          className={`max-w-4xl mx-auto mb-12 transition-all duration-1000 transform ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl border border-gray-700/50 p-8 lg:p-12 relative">
            {/* Quote Icon */}
            <div className="absolute -top-6 left-8 w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full flex items-center justify-center">
              <i className="ri-double-quotes-l text-white text-xl" aria-hidden="true"></i>
            </div>

            {/* Testimonial Content */}
            <div className="text-center">
              {/* Stars */}
              <div className="flex justify-center space-x-1 mb-6" role="img" aria-label={`${testimonials[currentTestimonial].rating} yıldız değerlendirme`}>
                {renderStars(testimonials[currentTestimonial].rating)}
              </div>

              {/* Content */}
              <blockquote className="text-xl lg:text-2xl text-gray-200 leading-relaxed mb-8 italic">
                "{testimonials[currentTestimonial].content}"
              </blockquote>

              {/* Author Info */}
              <div className="flex items-center justify-center space-x-4">
                <img
                  src={testimonials[currentTestimonial].avatar}
                  alt={`${testimonials[currentTestimonial].name} profil fotoğrafı`}
                  className="w-16 h-16 rounded-full object-cover border-2 border-blue-400/30"
                  loading="lazy"
                />
                <div className="text-left">
                  <div className="text-white font-bold text-lg">
                    {testimonials[currentTestimonial].name}
                  </div>
                  <div className="text-blue-400 font-medium">
                    {testimonials[currentTestimonial].position}
                  </div>
                  <div className="text-gray-400 text-sm">
                    {testimonials[currentTestimonial].company}
                  </div>
                </div>
              </div>

              {/* Project Type Badge */}
              <div className="mt-6 inline-flex items-center px-4 py-2 bg-blue-500/20 backdrop-blur-sm rounded-full border border-blue-400/30">
                <i className="ri-briefcase-line text-blue-400 mr-2 text-sm" aria-hidden="true"></i>
                <span className="text-blue-400 text-sm">
                  {testimonials[currentTestimonial].projectType}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial Navigation */}
        <div className="flex justify-center space-x-4 mb-12" role="tablist" aria-label="Müşteri yorumları navigasyonu">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentTestimonial(index)}
              className={`w-4 h-4 rounded-full transition-all duration-300 ${
                index === currentTestimonial
                  ? 'bg-blue-400 w-12'
                  : 'bg-gray-600 hover:bg-gray-500'
              }`}
              role="tab"
              aria-selected={index === currentTestimonial}
              aria-label={`${index + 1}. müşteri yorumunu göster`}
            />
          ))}
        </div>

        {/* All Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              onClick={() => setCurrentTestimonial(index)}
              className={`bg-gradient-to-br from-gray-800/30 to-gray-900/30 backdrop-blur-sm rounded-2xl border border-gray-700/30 p-6 cursor-pointer transition-all duration-300 hover:border-blue-500/50 hover:scale-105 ${
                index === currentTestimonial ? 'border-blue-500/50 bg-blue-500/10' : ''
              }`}
              role="button"
              tabIndex={0}
              aria-label={`${testimonial.name} yorumunu büyük ekranda göster`}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setCurrentTestimonial(index);
                }
              }}
            >
              <div className="flex items-center mb-4">
                <img
                  src={testimonial.avatar}
                  alt={`${testimonial.name} profil fotoğrafı`}
                  className="w-12 h-12 rounded-full object-cover mr-3 border border-gray-600"
                  loading="lazy"
                />
                <div>
                  <div className="text-white font-semibold">{testimonial.name}</div>
                  <div className="text-gray-400 text-sm">{testimonial.company}</div>
                </div>
              </div>

              <div className="flex space-x-1 mb-3" role="img" aria-label={`${testimonial.rating} yıldız değerlendirme`}>
                {renderStars(testimonial.rating)}
              </div>

              <p className="text-gray-300 text-sm leading-relaxed line-clamp-3">
                {testimonial.content}
              </p>

              <div className="mt-4 text-xs text-blue-400 font-medium">{testimonial.projectType}</div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-3xl font-bold text-blue-400 mb-2">99%</div>
            <div className="text-gray-400">Müşteri Memnuniyeti</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-cyan-400 mb-2">10+</div>
            <div className="text-gray-400">Başarılı Proje</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-blue-500 mb-2">10+</div>
            <div className="text-gray-400">Mutlu Müşteri</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-purple-400 mb-2">24/7</div>
            <div className="text-gray-400">Destek Hizmeti</div>
          </div>
        </div>
      </div>
    </section>
  );
}
